import { useState } from 'react'
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { useTranslation } from 'react-i18next'
import SimpleButton from '../SimpleButton'
import LoadingSpinner from '../LoadingSpinner'
import { toast } from '../Toast'
import { deletePaymentMethod } from '../../../utils/requests/paymentMethodsAPI'

const UpdateForm = (props) => {
  const { t } = useTranslation()
  const { paymentMethodIdToDelete, closeModal } = props
  const stripe = useStripe()
  const elements = useElements()
  const [showSpinner, setShowSpinner] = useState(false)

  const handleUpdate = async () => {
    setShowSpinner(true)

    try {
      if (paymentMethodIdToDelete) {
        await deletePaymentMethod(paymentMethodIdToDelete)
      }

      const { error } = await stripe.confirmSetup({
        elements,
        redirect: 'if_required',
        confirmParams: {
          return_url: window.location.href,
        },
      })

      if (error) {
        setShowSpinner(false)
        toast.error(t('error.fill_fields_correctly'))

        return
      }

      toast.success(t('coltene_store.succesfully_updated_payment_method'))

      await new Promise((resolve) => setTimeout(resolve, 10000))
      window.location.reload(true)
    } catch (error) {
      console.log('Payment method update error', error)
      setShowSpinner(false)

      toast.error(t('error.something_wrong'))
    }
  }

  return (
    <div className="update-form">
      <PaymentElement />
      <div className="update-form-footer">
        <SimpleButton className="cancel-button" onClick={() => closeModal()}>
          {t('cancel')}
        </SimpleButton>
        <SimpleButton className="submit-button" onClick={() => handleUpdate()}>
          {t('confirm')}
        </SimpleButton>
      </div>
      {showSpinner && (
        <div className={'spinner-wrapper'}>
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}

export default UpdateForm
